import domUtils from "common/helper/domUtils";


/**
 * Meant for keeping checks that are client-side only. Checked state should never be returned
 * from the server, and on refreshes of the list, we want to keep the checked items checked.
 *
 * Save
 * -Capture the current checked items
 *
 * Restore
 * -Checks the saved items, if they exist
 */


/**
 * Create a saved selection. Must call save() manually.
 * @param grid grid to operate on
 * @constructor
 */
var Selection = function(grid) {
    this.grid = grid;
    this.ids = new Set();
    this.uids = new Set();
};

Selection.prototype._checkRow = function(el) {
    var box = $(el).find("input[type='checkbox']");
    if (box.length) {
        box.click();
    }
};

/**
 * Scroll checkbox into view.
 *
 * @param el row element
 * @private
 */
Selection.prototype._scrollToRow = function(el) {
    var box = $(el).find("input[type='checkbox']");
    domUtils.scrollIntoView(box);
};

/**
 * Save the current checked items.
 */
Selection.prototype.save = function() {
    this.ids.clear();
    this.uids.clear();
    this.skip = false;
    var item;
    var selected = this.grid.checked();
    for (var i = 0; i < selected.length; i++) {
        item = this.grid.dataItem(selected[i]);
        if (item) {
            this.ids.add(item.get(item.idField || "id"));
            this.uids.add(item.uid);
        }
    }
    if (this.grid.tbody.find("tr").length == 0) {
        this.skip = true;
    }
};

/**
 * Restore the saved checked items.
 */
Selection.prototype.restore = function() {
    if (this.grid.checked().length) {
        return;
    }
    var rows = this.grid.tbody.find("tr[data-uid]");
    var checkedRows = [];
    var item;
    for (var i = 0; i < rows.length; i++) {
        item = this.grid.dataItem(rows[i]);
        if (item && ((item.get(item.idField || "id") && this.ids.has(item.get(item.idField || "id"))) || this.uids.has(item.uid))) {
            this._checkRow(rows[i]);
            checkedRows.push(rows[i]);
        }
    }

    // scroll to first checked row
    if (checkedRows.length > 0) {
        this._scrollToRow(checkedRows[0]);
    }
};

export default Selection;
